
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { GroupUserItemProps } from ".";
import { loading, create } from "store/group-user";
import { AppMessage } from "components";

interface ApiGroupUserRemoveUserInputProps {
    groupId: number;
    userIds: number[]
}

type ApiGroupUserRemoveUserOutputProps = OutputBaseProps<{ removed: number; }, ApiGroupUserRemoveUserInputProps>

export const apiGroupUserRemoveUser = async (data: ApiGroupUserRemoveUserInputProps) => {
    const res = (await axios.delete<ApiGroupUserRemoveUserOutputProps>("/api/group/users/remove", { data },))
        .data;
    if (res.code === 0 && res.data?.removed) {
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};